import Sprite = PIXI.Sprite;
import Graphics = PIXI.Graphics;
import Container = PIXI.Container;
import { createSprite } from '../../utils/GameEngine';
import { CoreController } from '../../core/CoreController';

export class Avatar extends Container {
    constructor(private imgUrl?: string, private myAvatar: boolean = false, public readonly playerID?: string) {
        super();
        this.drawLayout();
    }

    private async drawLayout(): Promise<void> {
        const background: Sprite = createSprite('versus_grey_background_round', this);
        let sprite: Sprite;
        if (this.imgUrl) {
            sprite = PIXI.Sprite.from(await this.imgUrl);
        } else if (this.myAvatar === true) {
            if (CoreController.getInstance().isFB()) {
                sprite = PIXI.Sprite.from(await FBInstant.player.getPhoto());
            } else {
                sprite = createSprite('donut');
            }
        } else {
            // TODO: ADD DEFAULT(BLANK AVATAR)
            sprite = createSprite('challenge_icon_side_player_unknown');
        }

        const mask: Graphics = new Graphics();
        mask.lineStyle(0);
        mask.beginFill(0xFF0000);
        mask.drawCircle(0, 0, background.height / 2 - 10);
        mask.endFill();
        mask.position.set(background.width / 2, background.height / 2 - 2);
        sprite.anchor.set(0.5, 0.5);
        sprite.position.set(background.width / 2, background.height / 2 - 2);
        sprite.width = mask.width;
        sprite.height = mask.height;
        sprite.mask = mask;

        const overlay: Sprite = createSprite('versus_overlay_round');
        overlay.anchor.set(0.5, 0.5);
        overlay.position.set(background.width / 2, background.height / 2 - 2);

        this.addChild(sprite);
        this.addChild(mask);
        this.addChild(overlay);
        this.pivot.set(this.width / 2 - 1, this.height / 2 - 2);
    }
}